import React, { FC } from "react";
import "../styles/product.css";
import {
  BrandsListData,
  CategoriesListData,
  CouponList,
  Page,
  ProductData,
  TaxListData,
} from "types";
import NoDataFound from "../assect/Images/9264885-removebg.png";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

interface CommonTableType {
  data:
    | ProductData[]
    | Page[]
    | BrandsListData[]
    | CategoriesListData[]
    | TaxListData[]
    | CouponList[];
  isLoading: boolean;
  headers: String[];
  renderRow: (product: any, index: number) => JSX.Element;
}

const CommonTable: FC<CommonTableType> = ({
  data,
  isLoading,
  headers,
  renderRow,
}) => {
  if (!isLoading && (!data || data.length === 0)) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
        <img src={NoDataFound} alt="No Data Found" width={400} height={300} />
      </div>
    );
  }

  return (
    <div className="product_main_third">
      <div className="product_main_third_table">
        <Table className="table">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={index}
                  className="justify-content-center"
                  sx={{ fontWeight: "bold" }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading
              ? Array.from(new Array(12)).map((_, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {headers.map((_, colIndex) => (
                      <TableCell key={colIndex}>
                        <Skeleton variant="text" width="80%" height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              : data.map((item, index) => renderRow(item, index))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default CommonTable;
